export class APISessionExpiredError<T> extends Error {
  response: T

  constructor(message: string, response?: T) {
    super(message)
    this.name = 'APISessionExpiredError'
    this.response = response
  }
}
